export type GoogleAdsClickType = 'gclid' | 'gbraid' | 'wbraid';

export interface GoogleAdsClick {
	Type: GoogleAdsClickType;
	Id: string;
}

interface StoredGoogleAdsClick extends GoogleAdsClick {
	timestamp: number;
}

const googleAdsClickCookies: Record<GoogleAdsClickType, string> = {
	gclid: '_gcl_aw',
	gbraid: '_gcl_ag',
	wbraid: '_gcl_gb',
};

// Google stores clicks as `GCL.<timestamp>.<id>` in `_gcl_aw`/`_gcl_gb`, but as `2.1.k<id>$i<timestamp>` in `_gcl_ag`.
const prefixedCookiePattern = /^GCL\.(\d+)\.(.+)$/;
const keyValueCookiePattern = /^\d+\.\d+\.k([^$]+)\$i(\d+)/;

const parseClickCookie = (type: GoogleAdsClickType, value: string): StoredGoogleAdsClick | null => {
	const prefixedMatch = prefixedCookiePattern.exec(value);

	if (prefixedMatch) {
		return { Type: type, Id: prefixedMatch[2], timestamp: Number(prefixedMatch[1]) };
	}

	const keyValueMatch = keyValueCookiePattern.exec(value);

	if (keyValueMatch) {
		return { Type: type, Id: keyValueMatch[1], timestamp: Number(keyValueMatch[2]) };
	}

	return null;
};

export const getGoogleAdsClickForOrder = (hasMarketingConsent: boolean, cookies: Record<string, string | undefined>): GoogleAdsClick | null => {
	if (!hasMarketingConsent) {
		return null;
	}

	const newestClick = (Object.keys(googleAdsClickCookies) as GoogleAdsClickType[])
		.map((type) => {
			const value = cookies[googleAdsClickCookies[type]];

			return value ? parseClickCookie(type, value) : null;
		})
		.reduce<StoredGoogleAdsClick | null>((newest, click) => (click && (!newest || click.timestamp > newest.timestamp) ? click : newest), null);

	return newestClick ? { Type: newestClick.Type, Id: newestClick.Id } : null;
};
